export const EMAIL_PROFILE_STICKY_HEADER_HEIGHT_PROPERTY =
  '--email-profile-sticky-header-height'
